import { HealthcareProviderP1Configuration } from '@dreryk/egabinet-p1-frontend-api';

import { FormContextValues, useFormController } from '@dreryk/react-common';
import { Button, FormRouteLeavingPrompt, FormValidationSnackbar } from '@dreryk/react-components';

import { P1IdentifierField } from './fields/P1IdentifierField';
import { useGetP1Configuration, useSetP1Identifier } from './P1IdentifierForm.hooks';
import { StyledP1IdentifierFormContent } from './StyledP1IdentifierFormContent';

export type P1IdentifierFormFields = {
   p1Identifier: string | null;
};
export type P1IdentifierFormController = FormContextValues<P1IdentifierFormFields>;

const P1_IDENTIFIER_FORM_INITIAL_VALUE: P1IdentifierFormFields = {
   p1Identifier: null,
};

const P1_IDENTIFIER_FORM_ID = 'p1IdentifierFormId';

type P1IdentifierFormProps = {
   readonly verifyAccountConfiguration: () => Promise<void>;
};
export const P1IdentifierForm = (props: P1IdentifierFormProps): JSX.Element => {
   const controller: P1IdentifierFormController = useFormController(P1_IDENTIFIER_FORM_INITIAL_VALUE, {
      resetAfterSubmit: true,
   });
   const updateP1IdentifierFormValue = (p1Identifier: HealthcareProviderP1Configuration['externalId'] | null): void => {
      controller.setValue('p1Identifier', p1Identifier);
   };
   const { loading: p1ConfigurationLoading } = useGetP1Configuration(updateP1IdentifierFormValue);
   const { execute: setP1Identifier } = useSetP1Identifier(props.verifyAccountConfiguration);
   const onSubmit = (data: P1IdentifierFormFields): void => {
      if (data.p1Identifier) {
         setP1Identifier(data.p1Identifier);
      }
   };

   return (
      <form id={P1_IDENTIFIER_FORM_ID} noValidate onSubmit={controller.handleSubmit(onSubmit)}>
         <StyledP1IdentifierFormContent testId={'p1Identifier'}>
            <P1IdentifierField register={controller.register} p1ConfigurationLoading={p1ConfigurationLoading} />
         </StyledP1IdentifierFormContent>
         <FormValidationSnackbar formState={controller.formState} />
         <FormRouteLeavingPrompt
            formState={controller.formState}
            title={'healthCareInstitution:communicationWithP1:p1Identifier:leavingPrompt.title'}
            message={'healthCareInstitution:communicationWithP1:p1Identifier:leavingPrompt.message'}
         />
         <Button
            testId={'saveP1Identifier'}
            type='submit'
            label={'healthCareInstitution:communicationWithP1:p1Identifier:saveP1Identifier'}
            blockingOperation
         />
      </form>
   );
};
